import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  CREATE_PACIENTE_REQUEST,
  CREATE_PACIENTE_SUCCESS,
  CREATE_PACIENTE_FAILURE,
  FETCH_PACIENTES_REQUEST,
  FETCH_PACIENTES_SUCCESS,
  FETCH_PACIENTES_FAILURE,
  FETCH_PACIENTES_EMPRESA_REQUEST,
  FETCH_PACIENTES_EMPRESA_SUCCESS,
  FETCH_PACIENTES_EMPRESA_FAILURE,
  SET_PACIENTES_PAGE,
  SET_PACIENTES_LIMIT,
  UPDATE_PACIENTE_REQUEST,
  UPDATE_PACIENTE_SUCCESS,
  UPDATE_PACIENTE_FAILURE,
  DELETE_PACIENTE_REQUEST,
  DELETE_PACIENTE_SUCCESS,
  DELETE_PACIENTE_FAILURE,
  TOGGLE_VISTA_PACIENTES
} from '../../../constants/pacientes/Paciente';
import { message } from 'antd';
import { RootState } from '../../store/store';
import fetchWithIP from '../../../redux/actions/utils/FechHeaders';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const createPacienteRequest = () => ({
  type: CREATE_PACIENTE_REQUEST
});

export const createPacienteSuccess = (data: any) => ({
  type: CREATE_PACIENTE_SUCCESS,
  payload: data
});

export const createPacienteFailure = (error: string) => ({
  type: CREATE_PACIENTE_FAILURE,
  payload: error
});

export const fetchPacientesRequest = () => ({
  type: FETCH_PACIENTES_REQUEST
});

export const fetchPacientesSuccess = (data: any) => ({
  type: FETCH_PACIENTES_SUCCESS,
  payload: data
});

export const fetchPacientesFailure = (error: string) => ({
  type: FETCH_PACIENTES_FAILURE,
  payload: error
});

export const fetchPacientesEmpresaRequest = () => ({
  type: FETCH_PACIENTES_EMPRESA_REQUEST
});

export const fetchPacientesEmpresaSuccess = (data: any) => ({
  type: FETCH_PACIENTES_EMPRESA_SUCCESS,
  payload: data
});

export const fetchPacientesEmpresaFailure = (error: string) => ({
  type: FETCH_PACIENTES_EMPRESA_FAILURE,
  payload: error
});

export const toggleVistaPacientes = (vistaEmpresa: boolean, usuarioId?: string) => ({
  type: TOGGLE_VISTA_PACIENTES,
  payload: { vistaEmpresa, usuarioId }
});

export const setPacientesPage = (page: number) => ({
  type: SET_PACIENTES_PAGE,
  payload: page
});

export const setPacientesLimit = (limit: number) => ({
  type: SET_PACIENTES_LIMIT,
  payload: limit
});

export const updatePacienteRequest = () => ({
  type: UPDATE_PACIENTE_REQUEST
});

export const updatePacienteSuccess = (data: any) => ({
  type: UPDATE_PACIENTE_SUCCESS,
  payload: data
});

export const updatePacienteFailure = (error: string) => ({
  type: UPDATE_PACIENTE_FAILURE,
  payload: error
});

export const deletePacienteRequest = () => ({
  type: DELETE_PACIENTE_REQUEST
});

export const deletePacienteSuccess = (pacienteId: string) => ({
  type: DELETE_PACIENTE_SUCCESS,
  payload: pacienteId
});

export const deletePacienteFailure = (error: string) => ({
  type: DELETE_PACIENTE_FAILURE,
  payload: error
});

export const createPaciente = (
  pacienteData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(createPacienteRequest());

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        'pacientes',
        {
          method: 'POST',
        },
        pacienteData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al crear el paciente');
      }

      dispatch(createPacienteSuccess(data));
      message.success('Paciente creado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al crear el paciente';
      dispatch(createPacienteFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchPacientes = (
  page: number = 1,
  limit: number = 10,
  search?: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>, getState: () => RootState) => {
    const { vistaEmpresa, usuarioFiltro } = getState().pacientes;
  
    
    dispatch(fetchPacientesRequest());

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let url = `pacientes?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }

      const response = await fetchWithIP(
        url,
        {
          method: 'GET',
        });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los pacientes');
      }

      dispatch(fetchPacientesSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener los pacientes';
      dispatch(fetchPacientesFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchPacientesEmpresa = (
  page: number = 1,
  limit: number = 10,
  search?: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    
    dispatch(fetchPacientesRequest());

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let url = `pacientes/empresa?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }

      const response = await fetchWithIP(
        url,
        {
          method: 'GET',
        });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los pacientes');
      }

      dispatch(fetchPacientesSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener los pacientes';
      dispatch(fetchPacientesFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const updatePaciente = (
  pacienteId: string,
  pacienteData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(updatePacienteRequest());

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `pacientes/${pacienteId}`,
        {
          method: 'PUT',
        },
        pacienteData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar el paciente');
      }

      dispatch(updatePacienteSuccess(data));
      message.success('Paciente actualizado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al actualizar el paciente';
      dispatch(updatePacienteFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const deletePaciente = (
  pacienteId: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(deletePacienteRequest());

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `pacientes/${pacienteId}`,
        {
          method: 'DELETE',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar el paciente');
      }

      dispatch(deletePacienteSuccess(pacienteId));
      message.success('Paciente eliminado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al eliminar el paciente';
      dispatch(deletePacienteFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};